export enum RingStyleEnum {
  Heritage = 'heritage',
  Horizon = 'horizon',
  OuraRing4 = 'oura-ring-4',
}
